import { useContext, useEffect, useState } from 'react'

// context
import { AppContext } from '../../../App'

// components
import DataTable from '../../data-table/data-table'
import Image from '../../image/image'
import StepCardLoader from '../../step-card-loader/step-card-loader'
import StepCard from '../../step-card/step-card'

// utils
import { callAPI } from '../../../utils/api'

// styles
import Tag from '../../tag/tag'
import styles from './deltav-page.module.scss'

const DeltaVPage = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const [isLoading, setLoading] = useState(true)

	const floatNumber = (number: number | undefined): string => {
		return `${Math.round((number ? number : 0) * 100) / 100}`
	}

	const SeverityTag = ({ deltav }: { readonly deltav?: number }) => {
		if (!deltav) return <></>

		let severity = 'Low'
		if (deltav >= 15 && deltav <= 30) severity = 'Medium'
		if (deltav > 30) severity = 'High'

		return <Tag theme={severity.toLowerCase()} label={severity} />
	}

	useEffect(() => {
		callAPI('deltav', {
			method: 'POST',
			body: JSON.stringify({
				s3Uri: appContext?.s3Uri,
				side: 'front',
			}),
			successCallback: (data) => {
				appContext?.setDeltaV(data)
				setLoading(false)
			},
			errorCallback: () => {
				appContext?.setDeltaV(undefined)
				setLoading(false)
			},
		})
	}, [])

	return (
		<StepCard stepTitle="Delta V">
			{isLoading ? (
				<StepCardLoader />
			) : (
				<div
					className={[styles.deltavPage, 'animate-appear']
						.join(' ')
						.trim()}
				>
					<div className={styles.images}>
						<Image src={appContext?.uploadedImage?.url} />
					</div>

					<div className={styles.tables}>
						<div>
							<DataTable
								headers={[
									{
										key: 'accident_details',
										label: 'Details',
									},
									{ key: 'details', label: '' },
								]}
								rows={[
									{
										accident_details: {
											content: 'Type of Vehicule',
										},
										details: {
											content: 'Car',
										},
									},
									{
										accident_details: {
											content: 'Severity of Damage',
										},
										details: {
											content: (
												<SeverityTag
													deltav={
														appContext?.deltaV
															?.deltav
													}
												/>
											),
										},
									},
									{
										accident_details: {
											content: 'Predicted Delta-V',
										},
										details: {
											content: `${floatNumber(
												appContext?.deltaV?.deltav
											)} km/h`,
										},
									},
									{
										accident_details: {
											content: 'Mean Error',
										},
										details: {
											content: `${floatNumber(
												appContext?.deltaV?.error
											)} km/h`,
										},
									},
								]}
							/>
						</div>
					</div>
				</div>
			)}
		</StepCard>
	)
}
export default DeltaVPage
